import { getApiUrl } from './getUrl';
import { initiateApi } from '@flemingmetrics/api-client';

export const API_CONFIG = {
  baseURL: getApiUrl(),
  withCredentials: true,
};

export const API = initiateApi(API_CONFIG);
